import { CommonModule, DatePipe } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { MessageType } from '../../../../_interfaces/entity';
import { ApiService } from '../../../../_services/api.service';
import { SharedService } from '../../../../_services/shared.service';
import { PaginationComponent } from '../../../_common/pagination/pagination.component';
import { DropdownComponent } from '../../../_common/dropdown/dropdown.component';
import { IDropdown } from '../../../../_interfaces/packageList';
import { DropdownSize } from '../../../../_interfaces/packageList';

@Component({
  selector: 'app-productivity-report',
  standalone: true,
  imports: [CommonModule, FormsModule, PaginationComponent,DropdownComponent],
  providers: [DatePipe],
  templateUrl: './productivity-report.component.html',
  styleUrl: './productivity-report.component.scss',
})
export class ProductivityReportComponent {
  @Input() coderNameList: string[] = [];
  @Input() selectedCase: IDropdown = { id: '', value: '' };
  monthsList: any[] = [];
  selectedDate: string = '';
  selectedMonth: any = '';
  tempSelectedDate: string = '';
  tempSelectedMonth: any = '';
  tempSelectedUser: string = '';

  isMonthly: boolean = true;
  selectedUser: string = '';
  apiService = inject(ApiService);
  sharedService = inject(SharedService);
  reportData: any[] = [];
  datePipe = inject(DatePipe);
  totalRecords: number = 0;
  pageNumber: any = 0;
  pageSize: number = 20;
  currentdate: Date = new Date();
  maxDate: String = this.currentdate.toISOString().split('T')[0];
  dropdownSize = DropdownSize.Medium; // ✅ OK

  ngOnInit() {
    this.populateMonthsList();
    this.loadAllData();
    this.angeionDataStorage();
    if (this.sharedService.caseNames().length == 0) this.getCaseNames();
  }

  angeionDataStorage() {
    const sources = localStorage.getItem('sources');
    if (sources) {
      const uniqueCols =
        JSON.parse(sources).angeionData_archive?.unique_columns;
      if (uniqueCols) {
        this.coderNameList = uniqueCols['User Name'];
      }
    }

    // if(!sources || sources && !JSON.parse(sources).angeionData) {
      // }

  }

  loadAllData() {
    this.sharedService.dashboardSessionStored.set(false);
    this.sharedService.showLoading();
    const data = {
      sourceSet: ['angeionData_archive'],
      client_id: 'Angieon_uuid',
    };
    const baseUrl = environment.baseUrlDashboard;
    this.apiService
      .dashboardPost(baseUrl + '/sourceApi/load_multiple_data', data)
      .subscribe({
        next: (data) => {
          // if (data) {
          //   const uniqueCols = data.sources?.angeionData?.unique_columns;
          //   if (uniqueCols) {
          //     // this.sharedService.dashboardCaseList.set(
          //     //   uniqueCols['Case Name']['Case Name']
          //     // );
          //     this.coderNameList = uniqueCols['User Name'];
          //   }
          //   if (data.sessions_dict) {
          //     sessionStorage.setItem(
          //       'session_dict',
          //       JSON.stringify(data.sessions_dict)
          //     );
          //     localStorage.setItem('sources', JSON.stringify(data.sources));
          //     //this.sharedService.isSessionStored.set(true);
          //     this.angeionDataStorage();
          //   }
          //   this.sharedService.dashboardSessionStored.set(true);
          // }
          this.sharedService.hideLoading();
        },
        error: (err) => {
          console.error('Error fetching data', err);
          this.sharedService.hideLoading();
        },
        complete: () => {
          this.sharedService.hideLoading();
        },
      });
  }
    getCaseNames() {
    this.sharedService.showLoading();
    this.apiService.get('user/cases').subscribe({
      next: (response) => {
        this.sharedService.hideLoading();
        if (response?.success == 'true') {
          const caseNames = response.data.map((item: any) => {
            const caseName: IDropdown = {
              id: item.id,
              value: item.value,
            };
            return caseName;
          });
          if (caseNames.length == 1 && this.selectedCase.id == '') {
            this.selectedCase = caseNames[0];
          }
          this.sharedService.caseNames.set(caseNames);
        }
      },
      error: (err) => {
        this.sharedService.hideLoading();
        this.sharedService.showToastMessage({
          message: err.message || 'Error',
          type: MessageType.error,
        });
      },
      complete: () => {},
    });
  }
  saveCase(caseName: IDropdown) {
    if (caseName) {
      this.selectedCase = caseName;
    }
  }
  populateMonthsList() {
    const currentDate = new Date();
    for (let i = 0; i < 3; i++) {
      const startDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - i,
        1
      );
      const endDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - i + 1,
        0
      );
      this.monthsList.push({
        startDate: this.datePipe.transform(startDate, 'yyyy-MM-dd'),
        endDate: this.datePipe.transform(endDate, 'yyyy-MM-dd'),
        month: this.datePipe.transform(startDate, 'MMMM yyyy'),
      });
    }

    console.log(this.monthsList);
  }

  applyProdReportFilter(pageNumber: number = 0) {
  if (!this.tempSelectedMonth && !this.tempSelectedDate) {
    return;
  }

  // Update selected filters
  this.selectedMonth = this.tempSelectedMonth;
  this.selectedDate = this.tempSelectedDate;

  // Set the current page number
  this.pageNumber = pageNumber;

  this.sharedService.showLoading();

  const queryParams = `coderName=${this.selectedUser}&startDate=${
    this.isMonthly ? this.selectedMonth.startDate : this.selectedDate
  }
  &endDate=${
    this.isMonthly ? this.selectedMonth.endDate : this.selectedDate}&pageSize=${this.pageSize}&startIndex=${this.pageNumber}&caseId=${this.selectedCase.id}&caseName=${this.selectedCase.value}`;

  this.apiService.get('package/report/search?' + queryParams).subscribe({
    next: (response) => {
      if (response?.success === 'true' && response?.data) {
        this.reportData = response.data.data;
        this.totalRecords = response.data.totalRecords;
        this.sharedService.filter.set({
          ...this.sharedService.filter(),
          startIndex: this.pageNumber,
        });
      }
    },
    error: (err) => {
      this.sharedService.showToastMessage({
        message: err.message || 'Error',
        type: MessageType.error,
      });
      this.sharedService.hideLoading();
    },
    complete: () => {
      this.sharedService.hideLoading();
    }
  });
}


  resetProdReportFilter() {
    this.selectedCase.value='';
    this.selectedCase.id='';
    this.selectedUser = '';
    this.tempSelectedDate = '';
    this.tempSelectedMonth = '';
    this.reportData = [];
  }

  paginationNavigation(pageno: any) {
  this.applyProdReportFilter(pageno - 1);
}


  downloadFile(): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/octet-stream',
      }),
      responseType: 'blob' as 'json', // Set responseType to 'blob' to handle binary data
    };

    // Adjust the API endpoint as needed
    return this.apiService.post(
      'https://so-api.staging.com/api/package/report/export',
      options
    );
  }

  exportReport() {
    this.sharedService.showLoading();
    const queryParams = `coderName=${this.selectedUser}&startDate=${
      this.isMonthly ? this.selectedMonth.startDate : this.selectedDate}&endDate=${this.isMonthly ? this.selectedMonth.endDate : this.selectedDate}&caseId=${this.selectedCase.id}&caseName=${this.selectedCase.value}`;
    this.apiService
      .exportPost('package/report/export?' + queryParams)
      .subscribe({
        next: (response) => {
          if (response) {
            this.saveFile(response, 'productivity-report.csv');
          }
        },
        error: (err) => {
          this.sharedService.showToastMessage({
            message: err.message || 'Error',
            type: MessageType.error,
          });
          this.sharedService.hideLoading();
        },
        complete: () => {
          this.sharedService.hideLoading();
        },
      });
  }

  saveFile(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  validateDate() {
    const today = new Date().toISOString().split('T')[0];
    if (this.selectedDate > today) {
      this.sharedService.showToastMessage({
        message: 'Future dates are not allowed!',
        type: MessageType.error,
      });
      this.selectedDate = '';
    }
  }
}
